import { Injectable } from '@angular/core';

import { IAggFuncParams, RowNode } from 'ag-grid-community';
import { get, has, isEmpty, isNil, reduce, set } from 'lodash';

import { AgGridReportsService } from '@services/reports/ag-grid-reports.service';

@Injectable({
    providedIn: 'root',
})
export class InventoryCountService {
    constructor(protected agGridReportsService: AgGridReportsService) {}

    private sumOfChildrenAfterGroup(childrenAfterGroup: RowNode[], field: string): number {
        const inventoryItemSumMap = {};
        return reduce(
            childrenAfterGroup,
            (sumValue, rowNode) => {
                if (isNil(rowNode.data)) {
                    return sumValue;
                }
                if (
                    !has(
                        inventoryItemSumMap,
                        `${rowNode.data.start_date}_${rowNode.data.count_name}_${rowNode.data.site_name}_${rowNode.data.item_code}_${field}`,
                    )
                ) {
                    const value = get(rowNode.data, field);
                    set(
                        inventoryItemSumMap,
                        `${rowNode.data.start_date}_${rowNode.data.count_name}_${rowNode.data.site_name}_${rowNode.data.item_code}_${field}`,
                        true,
                    );
                    return sumValue + parseFloat(value);
                }
                return sumValue;
            },
            0,
        );
    }

    public inventoryCountCustomSumAggFunc = (params: IAggFuncParams): number => {
        const defaultValue = 0;
        let sum = 0;
        if (isEmpty(params.columnApi.getRowGroupColumns())) {
            return this.sumOfChildrenAfterGroup(params.rowNode.childrenAfterGroup, params.colDef.field);
        }
        if (params.rowNode.leafGroup) {
            return this.sumOfChildrenAfterGroup(params.rowNode.childrenAfterGroup, params.colDef.field);
        } else {
            sum = reduce(
                params.values,
                (sumValue, currentValue) => {
                    return sumValue + parseFloat(currentValue);
                },
                0,
            );
        }
        this.agGridReportsService.totalSumValues[params.colDef.field] = sum === 0 ? defaultValue : sum;
        return sum;
    };
}
